import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivationStart, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, RouteConfigLoadStart, Router, Scroll } from '@angular/router';
import { debounceTime } from 'rxjs/operators';

import { SubscriptionBase } from './base';
import { LanguageHelper } from 'app/shared';
import { slideInAnimation } from 'app/shared/animations';



@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <mat-progress-bar style="z-index: 10;" class="position-absolute top-0 start-0 end-0 w-100" *ngIf="loading" color="primary" mode="indeterminate">
    </mat-progress-bar>
  `,
  animations: [
    slideInAnimation
  ],
  host: {
    'class': 'd-flex flex-row flex-nowrap align-items-start justify-content-start w-100 min-vh-100'
  }
})

export class AppComponent extends SubscriptionBase implements OnInit {
  // @HostBinding('@routeAnimations') get animationState(): string {
  //   return this.route.firstChild?.snapshot?.url.toString() || 'void';
  // }
  loading = false;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private languageHelper: LanguageHelper,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.languageHelper.updateTitle();
        }
      })
    );

    this.subscription.add(
      this.router.events.pipe(debounceTime(10)).subscribe((event) => {
        if ((event instanceof RouteConfigLoadStart && typeof event.route?.loadChildren === 'function') || event instanceof NavigationStart || event instanceof ActivationStart) {
          this.loading = true;
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError || event instanceof Scroll) {
          const initScreen = document.getElementById('init-screen');

          if (initScreen) {
            this.renderer.removeChild(initScreen.parentElement, initScreen);
          }
          this.loading = false;
        }
      })
    );
  }
}